import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { usePrevious } from "react-use";
import { useHydrated } from "remix-utils/use-hydrated";
import { useTypedStateFetcher } from "@commercekit/remix";

export const PrivateDataContext = createContext({
  loaded: false,
  loading: false,
});

export const usePrivateData = () => useContext(PrivateDataContext);

export const useLoadPrivateData = () => {
  const fetcher = useTypedStateFetcher();

  // Revalidate for root loader checkout & customer, to avoid page cache issue
  const [privateDataLoaded, setPrivateDataLoaded] = useState(false);
  const isHydrated = useHydrated();
  const prevRevalidateState = usePrevious(fetcher.state);
  const privateDataIsLoading = fetcher.state === "loading";
  useEffect(() => {
    if (isHydrated) {
      fetcher.submit({}, { action: "/revalidate", method: "post" });
    }
  }, [isHydrated]);

  useEffect(() => {
    if (prevRevalidateState === "loading" && fetcher.state === "idle") {
      setPrivateDataLoaded(true);
    }
  }, [prevRevalidateState, fetcher.state]);

  return useMemo(
    () => ({
      loaded: privateDataLoaded,
      loading: privateDataIsLoading,
    }),
    [privateDataLoaded, privateDataIsLoading]
  );
};
